import { render, staticRenderFns } from "./DataTableDocumentInput.vue?vue&type=template&id=3a075b56&scoped=true"
import script from "./DataTableDocumentInput.vue?vue&type=script&lang=js"
export * from "./DataTableDocumentInput.vue?vue&type=script&lang=js"
import style0 from "./DataTableDocumentInput.vue?vue&type=style&index=0&id=3a075b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a075b56",
  null
  
)

export default component.exports